import { AlertService } from '../../shared/services/alert.service';
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Scale } from "../../shared/models/scale";
import { AssessmentService } from "../../shared/services/assessment.service";
var ScaleNewComponent = /** @class */ (function () {
    function ScaleNewComponent(_assessmentService, alertService, route, router) {
        this._assessmentService = _assessmentService;
        this.alertService = alertService;
        this.route = route;
        this.router = router;
        this._scale = new Scale();
        this._scale.name = "Untitled";
        this._scale.id = this._assessmentService.newId();
    }
    ScaleNewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            var assessmentUid = params['uid'];
            _this._assessmentService.getAssessment(assessmentUid)
                .then(function (assessment) {
                _this._assessment = assessment;
            })
                .catch(function (error) {
                console.error(error);
            });
        });
    };
    Object.defineProperty(ScaleNewComponent.prototype, "scale", {
        get: function () {
            return this._scale;
        },
        set: function (v) {
            this._scale = v;
        },
        enumerable: true,
        configurable: true
    });
    ScaleNewComponent.prototype.save = function () {
        var _this = this;
        this._assessment.addScale(this.scale);
        this._assessmentService.saveAssessment(this._assessment).then(function () {
            _this.alertService.success("Scale Saved!");
            setTimeout(function () {
                _this.router.navigate(["../", _this.scale.id, "edit"], { relativeTo: _this.route, replaceUrl: true });
            }, 1500);
        }).catch(function (error) {
            _this.alertService.error("Error occurred in saving. Please try again.");
            console.error(error);
        });
    };
    ScaleNewComponent.prototype.saveAndCreateNew = function () {
        var _this = this;
        this._assessment.addScale(this.scale);
        this._assessmentService.saveAssessment(this._assessment).then(function (assessment) {
            _this.alertService.success("Scale Saved!");
            _this.scale = new Scale();
            _this.scale.id = _this._assessmentService.newId();
        })
            .catch(function (error) {
            console.log(error);
            _this.alertService.error("Error occurred in saving. Please try again.");
        });
    };
    return ScaleNewComponent;
}());
export { ScaleNewComponent };



// WEBPACK FOOTER //
// ./src/app/admin/scale-new/scale-new.component.ts.pre-build-optimizer.js